import qs from 'query-string';
import type { FacetOptionLocal } from '../DesignsGallery/components/Filters/Filter.types';
import { FILTER_QS_PARSE_OPTIONS } from '../DesignsGallery/utils/deriveActiveFiltersFromUrl';

/** Style slugs served as `Styles` tags by card_service; mirrors `StyleShowcase` STYLE_DEFINITIONS. */
export type StyleSlug = 'botanical' | 'floral' | 'elegant' | 'classic' | 'destination' | 'typographic' | 'rustic' | 'minimal' | 'vintage' | 'whimsical';

/**
 * A single gallery facet. The gallery ORs every selected facet together
 * (`useTagFilteredTemplates`), so a nav deep link must never carry more than one
 * facet group — this type only admits one composite code.
 */
export type GalleryFacet = FacetOptionLocal | `style:${StyleSlug}` | `style:${StyleSlug}|${StyleSlug}`;

/**
 * `?format=` on the gallery only steers tile price display and the format pill; it
 * does not filter templates (`useFormatSearchParam`). `print` is NOT a valid value.
 */
export type GalleryFormatParam = 'paper' | 'premiumDigital' | 'all';

export type GalleryHrefOptions = Readonly<{
  format?: GalleryFormatParam;
  facet?: GalleryFacet;
}>;

/**
 * Builds a gallery URL that the filters provider will parse back to exactly the
 * given facet: `?pf=price%3Dbasic`, `?pf=style%3Delegant%7Cclassic`.
 */
export const buildGalleryFilterHref = (basePath: string, options: GalleryHrefOptions = {}): string => {
  const query: Record<string, string> = {};
  if (options.format) query.format = options.format;
  if (options.facet) {
    const separatorIndex = options.facet.indexOf(':');
    const groupCode = options.facet.slice(0, separatorIndex);
    const valueCodes = options.facet.slice(separatorIndex + 1).split('|');
    query.pf = qs.stringify({ [groupCode]: valueCodes }, FILTER_QS_PARSE_OPTIONS);
  }
  return qs.stringifyUrl({ url: basePath, query }, { encode: true });
};
